import moment from 'moment'
import { jsonGet, jsonPost, commonThinxHeaders, deleteJson } from 'api'
import { buildQuery } from './helpers'
import { formatLocale } from 'shared/utils'

export const getSubscriptionByLocation = (locationId, startDate, promoCode, locale) => {
    const startDateQuery = buildQuery('startDate', startDate)
    const promoCodeQuery = buildQuery('promoCode', promoCode)
    const localeQuery = buildQuery('locale', locale, formatLocale)

    return jsonGet(
        `${window.THINX_BASE_SUBSCRIPTIONS_URL}/shop/locationRates?X-API-Key=${THINX_BASE_API_URL_API_KEY}&locationNo=${locationId}${startDateQuery}${promoCodeQuery}${localeQuery}`,
        null,
        {}
    )
        .then(resp => {
            if (resp?.type === 'E') {
                throw new Error(resp.message)
            }
            return resp
        })
        .catch(error => {
            throw new Error(error.message)
        })
}

export const getLocationProductRates = (locationId, startDate, productCode, promoCode, locale) => {
    const localeQuery = buildQuery('locale', locale, formatLocale)
    const promoCodeQuery = buildQuery('promoCode', promoCode)

    return jsonGet(
        `${window.THINX_BASE_SUBSCRIPTIONS_URL}/shop/productRates?isPreferredOnly=false&isWebOnly=false&locationNo=${locationId}&productCode=${productCode}&qty=1&sort=ASC&startDate=${startDate}${localeQuery}${promoCodeQuery}`,
        null,
        commonThinxHeaders(false, true)
    )
        .then(resp => {
            if (resp?.type === 'E') {
                throw new Error(resp.message)
            }
            return resp
        })
        .catch(error => {
            throw new Error(error.message)
        })
}

export const getOrderSummary = (data, token) => {
    let urlSuffix = ''
    const momentDate = moment(data.effectiveDate)
    if (momentDate.format('D') === '1') {
        urlSuffix = `?previewEndDate=${momentDate.add(1, 'months').format('MM/DD/YYYY')}&taxationItems=true`
    }

    const taxationAdditionalParameter = urlSuffix === '' && '?taxationItems=true'

    return jsonPost(
        `${window.THINX_BASE_SUBSCRIPTIONS_PORTAL_URL}/subscription/preview${urlSuffix || taxationAdditionalParameter}`,
        data,
        commonThinxHeaders(token)
    ).catch(error => {
        throw new Error(error.message)
    })
}

export const getCollectAddress = (token, locationId, locale) =>
    jsonGet(
        `${window.THINX_BASE_SUBSCRIPTIONS_PORTAL_URL}/place/shipping?locale=${formatLocale(
            locale
        )}&locationId=${locationId}`,
        null,
        commonThinxHeaders(token)
    )
        .then(resp => {
            if (resp?.type === 'E') {
                throw new Error(resp.message)
            }
            return resp
        })
        .catch(error => {
            throw new Error(error.message)
        })

export const getSummaryAddress = (token, locationId, locale) =>
    jsonGet(
        `${window.THINX_BASE_SUBSCRIPTIONS_PORTAL_URL}/shipping/location/summary/${locationId}?locale=${formatLocale(
            locale
        )}`,
        null,
        commonThinxHeaders(token)
    ).catch(error => {
        throw new Error(error.message)
    })

export const getTermsConditions = locationId =>
    jsonGet(
        `${window.THINX_BASE_SUBSCRIPTIONS_URL}/terms?type=SUBSCRIPTION${
            locationId ? `&activeOnly=true&locationId=${locationId}` : ''
        }`,
        null,
        {}
    )
        .then(resp => {
            if (resp?.type === 'E') {
                throw new Error(resp.message)
            }
            return resp
        })
        .catch(error => {
            throw new Error(error.message)
        })

export const purchaseSubscription = (data, queryParams, currentLocale, { shipChargeId }, token) => {
    const extraQueryParams = shipChargeId ? `&shipChargeId=${shipChargeId}&shipQuantity=1` : ''
    return jsonPost(
        `${window.THINX_BASE_SUBSCRIPTIONS_URL}/subscription/save?activate=true&payNow=true${queryParams}${extraQueryParams}&locale=${currentLocale}`,
        data,
        commonThinxHeaders(token, false, { 'Content-Type': 'application/json' })
    ).catch(error => {
        if (error.id) {
            cancelPurhcaseSubscription(data, error.id, token)
            throw new Error(error.message)
        }
        throw new Error(error.message)
    })
}

export const cancelPurhcaseSubscription = (data, id, token) =>
    deleteJson(
        `${window.THINX_BASE_SUBSCRIPTIONS_URL}/subscription/cancel?cancelEffectiveDate=${data.effectiveDate}&subscriptionId=${id}&policy=SpecificDate&terminationDate=${data.effectiveDate}`,
        null,
        commonThinxHeaders(token, false, { 'Content-Type': 'application/json' })
    ).catch(error => {
        throw new Error(error.message)
    })

export const addRateToWaitList = (
    requestedRateplanId,
    waitListId,
    accountId,
    requestedDate,
    requestOwner,
    token,
    locale
) =>
    jsonPost(
        `${window.THINX_BASE_WAITLIST_URL}/request/add?locale=${locale}`,
        {
            requestedRateplanId,
            waitListId,
            accountId,
            requestedDate,
            requestOwner,
        },
        commonThinxHeaders(token, false, { 'Content-Type': 'application/json' })
    ).catch(error => {
        throw new Error(error.message)
    })
